var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    fillRule: "nonzero",
    d: "M6.106 5.18l-1.064 5.05-.35-.074 1.064-5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDF1",
    fillRule: "nonzero",
    d: "M10.369 7.815h-.133l-.03-6.452h.133l.03 6.452zm-1.287.134h-.136l.002-5.861h.136l-.002 5.86zm2.66-.987l-.133.155-.006-6.02.132-.001.006 5.866zm1.26-1.357l-.134-.001-.004-4 .134.002.004 3.999zM7.835 7.456l-.132.002-.04-3.974.133-.002.04 3.974z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDF1",
    fillRule: "nonzero",
    d: "M7.13 4.631l.004.135 6.257-.028.102-.135-6.363.028zm-.107 1.43l.212.135 5.284-.03.202-.135-5.698.03zm.783-2.858l-.057.135 5.954-.033-.004-.135-5.893.033zm1.343-1.298l.006.135h4.131l-.006-.135H9.15zM7.591 7.363l.09.133 3.302.028.14-.135-3.532-.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDF1",
    fillRule: "nonzero",
    d: "M13.025 1.54c1.149 1.035.872 3.217-.618 4.872-1.491 1.656-3.631 2.159-4.78 1.124-1.15-1.035-.874-3.216.617-4.872 1.49-1.655 3.631-2.159 4.78-1.124zm-.112.125c-1.07-.963-3.109-.484-4.545 1.111-1.435 1.595-1.7 3.673-.63 4.636 1.07.962 3.109.483 4.544-1.112 1.436-1.594 1.7-3.673.63-4.635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    fillRule: "nonzero",
    d: "M13.896.849c1.528 1.476 1.13 4.367-.888 6.458-2.02 2.09-4.895 2.589-6.424 1.113-1.528-1.476-1.13-4.368.889-6.458C9.49-.13 12.367-.628 13.896.849zm-.436.45C12.217.1 9.726.532 7.924 2.398 6.12 4.264 5.777 6.768 7.02 7.97c1.243 1.2 3.734.769 5.537-1.098 1.802-1.866 2.147-4.37.903-5.571z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    fillRule: "nonzero",
    d: "M9.737 8.807l-5.01 1.24.086.347 5.01-1.239z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDF1",
    d: "M5.407 9.64c.213.206.22.546.013.76l-.622.644-.773-.747.622-.644a.537.537 0 0 1 .76-.014z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#509CF2",
    d: "M3.76 10.421l.902.871a.09.09 0 0 1 .002.127L1.206 15c-.497-.18-.86-.492-1.031-.996l3.458-3.58a.09.09 0 0 1 .126-.003z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.197,
    cy: 13,
    r: 1.956,
    fill: "#0C0B0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquash);
export default __webpack_public_path__ + "static/media/squash.6b443ee8a9ebfdb9219642fdd7047758.svg";
export { ForwardRef as ReactComponent };